import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { MarianomGeneral } from '../../marianom-general.service';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'vaciar-carrito-modal-mmax',
  templateUrl: './vaciar-carrito-modal-mmax.component.html',
  styleUrls: ['./vaciar-carrito-modal-mmax.component.scss']
})

export class VaciarCarritoModalMmaxComponent implements OnInit {

  constructor(private genServ : EcommerceGenericoService, private modal: ModalService) { }

  ngOnInit(): void {
  }

  vaciar() {
    this.modal.closeAll();
    this.genServ.resetEccomerce();
  }

  cancelar() {
    this.modal.closeAll();
  }

}
